<template>
  <div id="report-my">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-result.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    />
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(data, index) in reportDatas" :key="index">
        <div class="slide-wrapper">
          <div class="slide-container">
            <h1>{{data.type}}</h1>
            <p v-html="data.report"></p>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>

</template>

<script>
import common from '@/utils/common';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import CompHeader from '@/components/CompHeader';
import RESPONSE from '@/constants/response';
import CompLoading from '@/components/CompLoading';

export default {
  name: 'report-my',
  mixins: [
    common,
  ],
  components: {
    swiper,
    swiperSlide,
    CompHeader,
    CompLoading,
  },
  data() {
    return {
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.btn-next',
        },
        loop: true,
      },
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('report.mine'),

      reportDatas: [],

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,

      isLoading: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    getMyResult() {
      this.isLoading = true;
      this.$store.dispatch('getMyResult')
        .then((data) => {
          if (data.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getMyResult();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (data.status === RESPONSE.SUCCESS.CODE) {
            // R: 우뇌, A: 진취, S: 사회, P: 실천, B: 신체, L: 좌뇌
            this.reportDatas = [
              {
                type: data.data.R.BRAINTYPE,
                report: data.data.R.MATCHREPORT,
              },
              {
                type: data.data.A.BRAINTYPE,
                report: data.data.A.MATCHREPORT,
              },
              {
                type: data.data.S.BRAINTYPE,
                report: data.data.S.MATCHREPORT,
              },
              {
                type: data.data.P.BRAINTYPE,
                report: data.data.P.MATCHREPORT,
              },
              {
                type: data.data.B.BRAINTYPE,
                report: data.data.B.MATCHREPORT,
              },
              {
                type: data.data.L.BRAINTYPE,
                report: data.data.L.MATCHREPORT,
              },
            ];
          }
          this.isLoading = false;
        });
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  created() {
    this.getMyResult();
  },
  mounted() {
    this.isShowMenu(false);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/report-my.scss"></style>



// WEBPACK FOOTER //
// src/views/report/report-my.vue